import { useState, useCallback } from "react";

const useUiController = () => {
  const [loader, setLoader] = useState(false);

  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    color: "black",
    vertical:"bottom",
    horizontal:"left"
  });

  const INITIAL_DIALOG_CONFIG = {
    show: false,
    title: "",
    subTitle: "",
    handleSubmit: () => {},
    handleClose: () => {},
    outSideClickDismiss:true,
    negativeAction: "Dismiss",
    positiveAction: "",
    negativeReq:true,
    positiveReq:false,
    cancelExtra:true,
    onCancel:()=> {},
    gui:null,
    iconReq:false,
    iconContent:null,
  };

  const [dialogConfig, setDialogConfig] = useState(INITIAL_DIALOG_CONFIG);

  const [notificationConfig, setNotificationConfig] = useState({
    title: "",
    body: "",
    type: 1,
    timeout: 2000,
    func: () => {},
  });

  const showSnackbar = useCallback((message, color = "black",vertical = "bottom" ,horizontal = "left") => {
    console.log("showSNacbar,skand");
    setSnackbarConfig({
      open: true,
      message,
      color,
      vertical,
      horizontal
    });
  }, []);

  const closeSnackbar = useCallback(() => {
    setSnackbarConfig((prev) => ({
      ...prev,
      open: false,
    }));
  }, []);

  const showDialog = useCallback((config) => {
    setDialogConfig({
      ...config,
      show: true,
    });
  }, []);

  const closeDialog = useCallback(() => {
    setDialogConfig(INITIAL_DIALOG_CONFIG);
  }, []);

  const showNotification = useCallback((title, body, type = 1, func = () => {}, timeout = 2000) => {
    setNotificationConfig({
      title,
      body,
      type,
      func,
      timeout,
    });
  }, []);

  return {
    loader,
    setLoader,
    snackbarConfig,
    showSnackbar,
    closeSnackbar,
    dialogConfig,
    showDialog,
    closeDialog,
    notificationConfig,
    showNotification,
  };
};

export default useUiController;
